"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const CellEditMenu_vue_1 = __importDefault(require("./CellEditMenu.vue"));
const tableEditMode_1 = require("../tableEditMode");
const vue_3 = require("vue");
const osType_1 = require("../enums/osType");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CellEditMenuWrapper',
    props: {
        viewType: {
            type: String,
            default: "month",
        },
        isUsingRequestSlots: {
            type: Boolean,
            default: false,
        }
    },
    setup(__props) {
        const props = __props;
        const osType = (0, vue_3.ref)("");
        const cellEditMenu = (0, vue_3.ref)(null);
        const isVisibleCell = (0, vue_3.computed)(() => {
            return tableEditMode_1.cellEditMode.isMenuVisible;
        });
        const cellEditMenuStyle = (0, vue_3.computed)(() => {
            let x = tableEditMode_1.mouseCoordinates.mouseX;
            let y = tableEditMode_1.mouseCoordinates.mouseY;
            const menuElement = cellEditMenu.value;
            if (menuElement) {
                const menuWidth = menuElement.offsetWidth;
                const menuHeight = menuElement.offsetHeight;
                // Prevent overflow on the right
                if (x + menuWidth > window.innerWidth) {
                    x = x - menuWidth;
                }
                // Prevent overflow at the bottom
                if (y + menuHeight > window.innerHeight) {
                    y = y - menuHeight;
                }
            }
            return {
                top: `${y}px`,
                left: `${x}px`,
            };
        });
        function handleEditMenuPos(e) {
            cellEditMenu.value = e.value;
        }
        function getOS() {
            const userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.includes("mac")) {
                return osType_1.OSType.MAC;
            }
            if (userAgent.includes("win")) {
                return osType_1.OSType.WINDOWS;
            }
            if (userAgent.includes("android")) {
                return osType_1.OSType.ANDROID;
            }
            if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
                return osType_1.OSType.IOS;
            }
            return osType_1.OSType.UNKNOWN;
        }
        (0, vue_3.onMounted)(() => {
            osType.value = getOS();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                (0, vue_2.createElementVNode)("div", {
                    class: "cell-edit-menu-container",
                    style: (0, vue_2.normalizeStyle)(cellEditMenuStyle.value)
                }, [
                    (isVisibleCell.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CellEditMenu_vue_1.default, {
                            key: 0,
                            "os-type": osType.value,
                            "view-type": __props.viewType,
                            "is-using-request-slots": __props.isUsingRequestSlots,
                            onEditMenuRef: handleEditMenuPos
                        }, null, 8 /* PROPS */, ["os-type", "view-type", "is-using-request-slots"]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ], 4 /* STYLE */)
            ]));
        };
    }
});
